<template>
	<AutoComplete
		v-if="field.type === 'autocomplete'"
		v-model="field.value"
		v-bind="field"
	/>
	<Select
		v-else-if="field.type === 'select'"
		v-model="field.value"
		v-bind="field"
	/>
	<TextInput
		v-else-if="field.type === 'email'"
		v-model="field.value"
		v-bind="field"
	/>
	<TextInput
		v-else
		v-model="field.value"
		v-bind="field"
	/>
</template>

<script>
import AutoComplete from "./AutoComplete";
import Select from "./Select";
import TextInput from "./TextInput";

export default {
	components: {
		AutoComplete,
		Select,
		TextInput,
	},
	props: {
		field: Object,
	}
}
</script>
